export class CitySearch {
  provinceId: string;
  }